/**
 * Styled Components - Created by cazarez on 10/04/18.
 */
import Icon from 'antd/lib/icon'
import Spin from 'antd/lib/spin'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 20px 12px;
  min-height: 54vh;
  font-family: Avenir;
  background: #f4f4f4;
  max-width: 1460px;
  margin: 0 auto;
  @media (max-width: 1024px) {
    padding: 24px 12px;
  }
`

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-block: 68px 44px;
  position: relative;
  row-gap: 38px;
  column-gap: 50px;
  @media (max-width: 698px) {
    margin-top: 36px;
  }
`

export const StyledSpin = styled(Spin)`
  position: absolute;
  width: 100%;
  top: -30px;
`

export const BlogCard = styled.div`
  background: white;
  padding-bottom: 10px;
  min-width: 64px;
  width: 100%;
  display: flex;
  flex-flow: column;
  border-radius: 3px;
  box-shadow: 1px 1px 6px 1px #d5d5d5;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.03);
  }
  @media (min-width: 768px) {
    max-width: 308px;
  }
`

export const BlogImage = styled.img`
  width: 100%;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  height: 98px;
  object-fit: cover;
`

export const BlogTitle = styled.div`
  padding: 6px 16px;
  font-size: 18px;
  font-weight: bold;
`

export const BlogDesc = styled.div`
  padding: 0px 16px;
  font-size: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const BlogIcon = styled.img`
  max-width: 28px;
  border-radius: 50%;
  margin-right: 9px;
`

export const BlogCat = styled.div`
  text-transform: capitalize;
  font-size: 11px;
  background: #e4eeff;
  border-radius: 25px;
  padding: 1px 8px 1px 6px;
  margin-bottom: 2px;
  color: #5d677b;
`

export const BlogTag = styled(Icon)`
  margin-right: 4px;
  vertical-align: middle;
  color: #909eb8;
`

export const BlogStamps = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 14px;
  margin-top: 8px;
  align-items: flex-end;
  flex: 1;
`

export const BlogLeft = styled.div`
  font-size: 12px;
  color: gray;
`

export const BlogRight = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
`

export const BlogTime = styled.div`
  font-size: 11px;
  text-align: right;
  margin-bottom: 3px;
  color: gray;
`

export const EmptyResults = styled.div``

export const TagsList = styled.div`
  margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 14px;
  row-gap: 12px;
`

export const TagDiv = styled.div`
  background: white;
  padding: 4px 10px;
  border-radius: 25px;
  box-shadow: 1px 1px 4px -1px #b8b8b8;
  color: #75859f;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  ${({ secondary }: { secondary?: boolean }) => secondary ? `
    box-shadow: none;
    background: #94c4c9;
    color: white;
  ` : ''}
`

export const CloseIcon = styled(Icon)`
  background: white;
  color: #649095;
  margin-right: -4px;
  border-radius: 25px;
  margin-left: 6px;
  padding: 3px;
  vertical-align: top;
  margin-top: 1px;
  margin-bottom: -2px;
  font-size: 10px;
`

export const LikeIcon = styled(Icon)`
  margin-right: 4px;
  font-size: 12px;
  color: cornflowerblue;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
    color: 
  }
  @media (max-width: 698px) {
    font-size: 14px;
    margin-left: 4px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Blogs/styledComponents.tsx